module.exports = __webpack_public_path__ + "static/media/jjl.02c8bd82.png";